import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const AffectedItemsDamageDomesticStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS_DAMAGE_DOMESTIC
};
